import React from 'react';
import type { AtlassianAnalyticsApp as LazyAtlassianAnalyticsAppType } from '@atlassian/jira-spa-apps-servicedesk-atlassian-analytics/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyAtlassianAnalytics = lazyForPaint<typeof LazyAtlassianAnalyticsAppType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-atlassian-analytics", jiraSpaEntry: "async-servicedesk-atlassian-analytics" */ '@atlassian/jira-spa-apps-servicedesk-atlassian-analytics'
		),
	),
);

export const AtlassianAnalytics = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAtlassianAnalytics}
		pageId="spa-apps/servicedesk/atlassian-analytics"
		shouldShowSpinner
	/>
);
